module.exports = {
  //HERO
  typeWriterArray: [
    'National Accelerator Lab',
    'University of Southern California',
    'CalTech',
    'City of Anaheim',
    'University of Colorado Boulder',
    'Wawa',
    'Yale University',
    'Wayfair',
    'McGill',
    'Fermilab',
    'University of South Carolina',
    'Coffee Bean and Tea Leaf Company',
    'Stanford University',
    'Cook County',
    'University of North Florida',
    'Taylor',
    'Northwestern University',
    'Clark County',
    'UCONN',
    'University of Houston',
    'Corrigo',
    'University of Arkansas',
    'Michigan State University',
    'Texas Department of Transportation',
    'North Dakota University System',
    'TSSI',
    'Georgia Tech',
    'University of Rochester',
    'National Renewable Energy Labs',
    'Brown University',
    'Dallas County',
    'Iowa State University',
    'Duke University',
    'Lane Commercial',
    'Kent State University',
    'Columbus City Schools',
    'Cal Poly',
    'Ohio Department of Corrections',
    'Rice University',
    'Accruent',
    'University of Regina',
    'Fresno County',
    'University of New Hampshire',
    'DSL',
    'University of Illinois at Chicago',
    'University of Vermont',
    'University of Southern Oregon',
    'DePauw',
    'Pima Community College',
    'University of Victoria',
    'Baker College',
    'University of the Pacific',
    'Lafayette College',
    'Lindenwood'
  ],
}


// WEBPACK FOOTER //
// ./data/customersContent.js